import {Rule} from '@/types/FormErrors';

export const requiredRule: Rule<string|number|File> = (value): true|string => !!value || 'Pole jest wymagane';

const emailRegExp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line max-len
export const emailRule: Rule<string> = (value): boolean|string => value
  ? emailRegExp.test(value) || 'Podany e-mail jest nieprawidłowy'
  : false;

export const fileTypeRule: Rule<File> = (value): boolean|string => {
  return value
    ? (value.type === 'image/jpeg' || value.type === 'image/png' || value.type === 'image/gif')
      || 'Nieprawidołowy format pliku'
    : false;
};
